<template>
  <span class="flex items-center">
    <input
      :id="fieldId"
      type="checkbox"
      :name="name"
      class="appearance-none cursor-pointer border-2 rounded-sm border-primary-400 bg-transparent checked:bg-highlight checked:border-highlight w-5 h-5 flex-none"
      :checked="checked"
      @change="$emit('change', $event.target.checked)"
    />
    <!-- A real <label for>: clicking the text toggles the box, and screen
         readers announce the box with its name. -->
    <label :for="fieldId" class="ml-2 text-white text-sm cursor-pointer">
      {{ label }}
    </label>
  </span>
</template>

<script>
let uid = 0;

export default {
  name: "Checkbox",
  // Lets callers use `v-model` on the component.
  model: { prop: "checked", event: "change" },
  props: {
    name: { default: "" },
    label: { default: "" },
    checked: { type: Boolean, default: false },
  },

  data() {
    return {
      fieldId: `checkbox-${(uid += 1)}`,
    };
  },
};
</script>

<style scoped>
/* A tick mark, so "checked" isn't communicated by fill colour alone. */
input[type="checkbox"]:checked {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23292B3A'%3E%3Cpath d='M16.7 5.3a1 1 0 0 1 0 1.4l-7.5 7.5a1 1 0 0 1-1.4 0L3.3 9.7a1 1 0 1 1 1.4-1.4l3.8 3.8 6.8-6.8a1 1 0 0 1 1.4 0z'/%3E%3C/svg%3E");
  background-size: 90%;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
